import {GET_STATS_LANDING , GET_STATS_LANDING_ERROR , GET_STATS_LANDING_LOADING} from 'app/types'

const initialState = {
    stats : {},
    loading:false,
    error : null
}

export default function couponReducer (state = initialState, action) {

    switch(action.type){
        case GET_STATS_LANDING:
            return {
                ...state,
                stats : action.payload ,
                loading : false
            }
        case GET_STATS_LANDING_ERROR :
            return {
                ...state,
                loading: false ,
                error : action.payload
            }
        case GET_STATS_LANDING_LOADING :
            return {
                ...state ,
                loading: true,
                error: null
            }

        default: return state
    }

}